import _ from "lodash";
import * as React from "react";

import { PaginatedData } from "src/library/utils";
import { LoadingSpinner } from "src/library/components/LoadingSpinner";
import { Button } from "src/library/components/Button";
import Grid from "src/library/components/Hedron";
import { Icons } from "src/library/components/Icon/types";
import {
  ListAuditLogParams,
  ordersApi,
  IOrderAuditLog
} from "src/core/orders/api/orders.api";
import { ErrorNotice } from "src/core/shared/components/ErrorNotice";

import { AuditLogDateGroup } from "./AuditLogDateGroup";
import { AuditLogItem } from "./AuditLogItem";

interface OrderAuditLogsParams {
  orderId: number;
}

export const OrderAuditLogs: React.ReactFCWithChildren<OrderAuditLogsParams> = ({ orderId }) => {
  const [ listAuditLogsRes, listAuditLogsReq ] = ordersApi<PaginatedData<IOrderAuditLog>>("LIST_ORDER_AUDIT_LOGS");

  // pagination state for infinite scroll
  const [ pagination, setPagination ] = React.useState<ListAuditLogParams["pagination"]>({
    offset: 0,
    page: 0,
    limit: 20,
    sort: [ [ "createdAt", "DESC" ] ]
  });

  const [ auditLogs, setAuditLogs ] = React.useState<IOrderAuditLog[]>([]);

  const logsByDate: {[date: string]: IOrderAuditLog[]} = React.useMemo(() => {
    const groupedLogsByDate = _.groupBy(auditLogs, "createdAt");

    return groupedLogsByDate;
  }, [ auditLogs ]);

  React.useEffect(() => {
    listAuditLogsReq<ListAuditLogParams>({
      orderId,
      pagination
    });
  }, [ pagination ]);

  React.useEffect(() => {
    if (listAuditLogsRes.data) {
      setAuditLogs(al => {
        if (listAuditLogsRes.data) {
          return _.uniqBy(_.concat(al, listAuditLogsRes.data.result), "id");
        }

        return al;
      });
    }
  }, [ listAuditLogsRes ]);

  return (
    <>
      {_.map(logsByDate, (logs, createdAt) => (
        <>
          <AuditLogDateGroup
            createdAt={new Date(createdAt)}
            updatedByUser={logs[ 0 ].updatedByUser}
          >
            {_.map(logs, auditLog => <AuditLogItem auditLog={auditLog} />)}
          </AuditLogDateGroup>
        </>
      ))}

      {listAuditLogsRes.data && listAuditLogsRes.data?.count > auditLogs.length && (
        <Grid.Bounds
          direction="vertical"
          align="center"
        >
          <Grid.Box>
            <Button
              icon={Icons.CHEVRONDOWN}
              iconPosition="right"
              $buttonType="plain"
              onClick={() => setPagination({
                ...pagination,
                offset: auditLogs.length
              })}
            >
              Show more
            </Button>
          </Grid.Box>
        </Grid.Bounds>
      )}

      {listAuditLogsRes.pending && (
        <LoadingSpinner
          type="flat"
          position="inline"
        />
      )}

      {listAuditLogsRes.error && (
        <Grid.Bounds
          align="center"
          direction="vertical"
        >
          <ErrorNotice
            type="error"
            message={listAuditLogsRes.error.message}
          />

          <Grid.Box width={200}>
            <Button
              onClick={() => {
                listAuditLogsReq<ListAuditLogParams>({
                  orderId,
                  pagination
                });
              }}
            >
              Retry
            </Button>
          </Grid.Box>
        </Grid.Bounds>
      )}
    </>
  );
};
